import axios from "axios";
import { Dropdown } from "flowbite-react";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";

const Lowongan = () => {
  const { state, handleFunction } = useContext(GlobalContext);

  const { currentId, setCurrentId, search, setSearch, filter, setFilter } =
    state;

  const { handleDetail, handleChangeSearch, handleChangeFilter } =
    handleFunction;

  const [data, setData] = useState(null);

  //indikator
  const [fetchStatus, setFetchStatus] = useState(true);

  useEffect(() => {
    if (fetchStatus === true) {
      axios
        .get("https://dev-example.sanbercloud.com/api/job-vacancy")
        .then((res) => {
          let data = res.data.data;
          console.log(data);
          setData([...data]);
        })
        .catch((err) => {
          console.log(err);
        });
      setFetchStatus(false);
    }
  }, [fetchStatus]);

  const handleText = (params) => {
    if (params === null) {
      return "";
    } else {
      return params.slice(0, 120) + "...";
    }
  };

  const handleFilter = (event) => {
    event.preventDefault();
    console.log(filter);

    axios
      .get("https://dev-example.sanbercloud.com/api/job-vacancy")
      .then((res) => {
        let data = res.data.data;
        console.log(data);
        let filterData = data.filter((res) => {
          return (
            res.job_type === filter.job_type ||
            res.job_tenure === filter.job_tenure ||
            res.company_city === filter.company_city
          );
        });
        console.log(filterData);
        setData([...filterData]);
      })
      .catch((err) => {
        console.log(err);
      });
    setFetchStatus(false);
    setFilter({
      company_city: "",
      job_tenure: "",
      job_type: "",
    });
  };

  const rupiah = (number) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
    }).format(number);
  };

  const handleSearch = (event) => {
    event.preventDefault();

    console.log(search);

    axios
      .get("https://dev-example.sanbercloud.com/api/job-vacancy")
      .then((res) => {
        let data = res.data.data;
        console.log(data);
        let searchData = data.filter((res) => {
          return Object.values(res)
            .join("")
            .toLowerCase()
            .includes(search.toLowerCase());
        });
        console.log(searchData);
        if (searchData !== null) {
          setData([...searchData]);
        } else {
          return "";
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setSearch("");
    setFetchStatus(false);
  };

  return (
    <React.Fragment>
      <div className="bg-slate-500 w-full pb-10 rounded-t-lg">
        <h1 className="text-2xl uppercase text-center text-white p-10">
          Yuk cari pekerjaan yang cocok untuk kamu
        </h1>
        <form
          onSubmit={handleSearch}
          className="flex justify-center items-center"
        >
          <label htmlFor="simple-search" className="sr-only">
            Cari Disini...
          </label>
          <div className="relative w-1/4">
            <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
              <svg
                aria-hidden="true"
                className="w-5 h-5 text-gray-500 dark:text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <input
              type="text"
              id="simple-search"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-cyan-500 focus:border-cyan-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Search"
              value={search}
              onChange={handleChangeSearch}
              required
            />
          </div>
          <button
            type="submit"
            className="p-2.5 ml-2 text-sm font-medium text-white bg-cyan-500 rounded-lg border border-slate-200 hover:bg-cyan-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <span className="sr-only">Search</span>
          </button>
        </form>
        <div className="mt-3 flex justify-center">
          <button
            onClick={() => setFetchStatus(true)}
            type="submit"
            className=" p-2.5 ml-2 text-sm font-medium text-white bg-red-500 rounded-lg border border-slate-200 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Reset Pencarian
            <span className="sr-only">Search</span>
          </button>
        </div>
      </div>
      <div className="bg-cyan-500 w-full rounded-b-lg">
        <section className="overflow-hidden pb-10">
          <div className="ml-5 my-5 w-1/2 border-cyan-500 border-solid border-2">
            <h1 className="pl-4  text-white text-xl uppercase">
              Yuk Filter kerjaan <br /> sesuai sama yang kamu cari
            </h1>
          </div>
          <form onSubmit={handleFilter}>
            <div className="w-3/4 m-6">
              <div>
                <label
                  htmlFor="company_city"
                  className="block my-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  Domisili
                </label>
                <input
                  onChange={handleChangeFilter}
                  value={filter.company_city}
                  type="text"
                  id="company_city"
                  name="company_city"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>
              <div>
                <label
                  htmlFor="job_tenure"
                  className="block my-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  Jenis Kontrak Kerja
                </label>
                <input
                  onChange={handleChangeFilter}
                  value={filter.job_tenure}
                  type="text"
                  id="job_tenure"
                  name="job_tenure"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>
              <div>
                <label
                  htmlFor="job_type"
                  className="block my-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  Tipe Kerja
                </label>
                <input
                  onChange={handleChangeFilter}
                  value={filter.job_type}
                  type="text"
                  id="job_type"
                  name="job_type"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>
            </div>
            <button
              type="submit"
              className="ml-6 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              Filter
            </button>
          </form>
          <div className="mt-3">
            <button
              onClick={() => setFetchStatus(true)}
              type="submit"
              className=" p-2 ml-6 text-sm font-medium text-white bg-red-500 rounded-lg border border-slate-200 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              Reset Filter
              <span className="sr-only">Filter</span>
            </button>
          </div>
          <div className="container px-5 mx-auto py-3 lg:px-32">
            <div className="flex flex-wrap -m-1 md:-m-2">
              {data !== null &&
                data.map((res) => {
                  return (
                    <div
                      key={res.id}
                      className=" my-2 w-full md:w-1/2 lg:w-1/3"
                    >
                      <div className="m-2 h-fit md:h-full max-w-sm bg-white rounded-lg border border-gray-200 shadow-md">
                        <img
                          className=" mx-auto h-1/4 w-1/2 mt-4"
                          src={res.company_image_url}
                          alt="company"
                        />
                        <div className="p-5">
                          <h5 className="mb-2 text-sm font-semibold tracking-tight text-blue-700 dark:text-white">
                            {res.company_name}
                          </h5>
                          <h5 className="my-2 text-xl font-bold tracking-tight text-gray-900 dark:text-white">
                            {res.title}
                          </h5>
                          <p className="my-2 font-normal text-gray-700 dark:text-gray-400">
                            {handleText(res.job_description)}
                          </p>
                          <hr />
                          <h5 className="my-2 text-sm font-semibold tracking-tight text-gray-900 dark:text-white">
                            Domisili: {res.company_city}
                          </h5>
                          <h5 className="my-2 text-sm font-semibold tracking-tight text-gray-900 dark:text-white">
                            Kontrak Kerja: {res.job_tenure}
                          </h5>
                          <h5 className="my-2 text-sm font-semibold tracking-tight text-gray-900 dark:text-white">
                            Tipe Kerja: {res.job_type}
                          </h5>
                          <hr />
                          <h5 className="mt-2 mb-5 text-sm font-semibold tracking-tight text-gray-900 dark:text-white">
                            Gaji: {rupiah(res.salary_min)} -{" "}
                            {rupiah(res.salary_max)}
                          </h5>
                          {res.job_status === 1 && (
                            <h5 className="block mb-4 text-md font-semibold tracking-tight bg-green-400 text-center p-2 rounded-lg text-white dark:text-white">
                              Masih Dibuka
                            </h5>
                          )}
                          {(res.job_status === 0 ||
                            res.job_status === null) && (
                            <h5 className="mb-4 text-md font-semibold tracking-tight bg-red-500 inline p-2 rounded-lg text-white dark:text-white">
                              Sudah Ditutup
                            </h5>
                          )}
                          {res.job_status === 1 && (
                            <button
                              value={res.id}
                              onClick={handleDetail}
                              type="button"
                              className="text-white capitalize w-full bg-cyan-500 hover:bg-cyan-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                            >
                              Detailnya klik disini ya
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default Lowongan;
